<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <div>
      <LmBreadcrumb v-if="showBreadcrumb" />
      <h4>Nuevo Documento</h4>
      <div>
        <div class="row">
          <div class="col-12 col-lg-12">
            <LmTextArea
              v-model="form.descripcion"
              :v="$v.form.descripcion"
              label="Descripcion"
              placeholder="Descripcion "
              />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-12 mb-3">
            <LmUploadFiles
              :dropzoneOptions="dropzoneOptions"
              v-on:vdropzone-removed-file="fileRemoved"
              v-on:vdropzone-success="fileCreated"
            />
          </div>
        </div>
      </div>
      <form
        @submit.prevent="submit"
        novalidate
        class="position-relative">
        <LmButton
          v-if="enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click.native="goBackBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="!enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('Cancel')"
          @click.native="cancelBtn"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="!enableGoBackButton"
          type="submit"
          buttonClass="btn-primary"
          :isProcessing="formIsProcessing"
          :value="$t('Save')"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import { required } from 'vuelidate/lib/validators'
import LmButton from '@/components/form/elements/LmButton'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmTextArea from '@/components/form/elements/LmTextArea'

export default {
  components: {
    LmButton,
    LmUploadFiles,
    LmTextArea
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      files: [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/?id=${this.$route.params.id}`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFilesize: 50,
        timeout: 120000,
        addRemoveLinks: true
      },
      form: {
        descripcion: ''
      },
      formIsProcessing: false
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail'])
  },
  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    // La uri tanto para obtener la configuracion desde settings como
    // para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  validations: {
    form: {
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    goBackBtn () {
      this.$router.go(-1)
    },
    cancelBtn () {
      if (!this.files.length) {
        this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.id}`)
      } else {
        if (confirm(this.$t('cancel_msg'))) {
          this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.id}`)
        }
      }
    },
    submit () {
      this.formIsProcessing = true
      /**
       * Se persisten los datos
       */
      let insertAttributes = {
        id: this.$route.params.id,
        description: this.form.descripcion,
        files: this.files
      }
      this.updateItemDetail({
        path: 'documentos/asociar/',
        data: insertAttributes
      })
        .then(() => {
          this.formIsProcessing = false
          this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.id}`)
        })
        .catch(e => {
          this.formIsProcessing = false
          console.log(e)
          alert(this.$t('try_again_later'))
        })
    },
    fileCreated (file, response) {
      if (response) {
        this.files.push(response)
      }
    },
    fileRemoved (file, error, xhr) {
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
    }
  },
  created () {
  }
}
</script>

<style lang="sass" scoped>
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
  h4, h5
    margin-bottom: 30px !important
</style>
